module.exports = __webpack_public_path__ + "static/media/ninia.af42ddeb.png";